import Vue from 'vue'
import Router from 'vue-router'
import BaseRouter from 'baseapp/router/router'

const shortcut = r => require.ensure([], () => r(require('buyerapp/views/shortcut/shortcut')), 'shortcut')
const goods = r => require.ensure([], () => r(require('buyerapp/views/goods/goods')), 'goods')
const recommend = r => require.ensure([], () => r(require('buyerapp/views/recommend/recommend')), 'recommend')
const self = r => require.ensure([], () => r(require('buyerapp/views/self/self')), 'self')
const goodsDetail = r => require.ensure([], () => r(require('buyerapp/views/goods/goodsDetail')), 'goodsDetail')
const shoppingCart = r => require.ensure([], () => r(require('buyerapp/views/cart/cart')), 'shoppingCart')
const order = r => require.ensure([], () => r(require('buyerapp/views/order/order')), 'order')
const orderResult = r => require.ensure([], () => r(require('baseapp/views/order/orderResult')), 'orderResult')
const orderDetail = r => require.ensure([], () => r(require('buyerapp/views/order/orderDetail')), 'orderDetail')
const shareOrderDetail = r => require.ensure([], () => r(require('buyerapp/views/order/orderDetail')), 'shareOrderDetail')
const addressManage = r => require.ensure([], () => r(require('buyerapp/views/address/addressManage')), 'addressManage')
const editAddress = r => require.ensure([], () => r(require('buyerapp/views/address/editAddress')), 'editAddress')
const selAddress = r => require.ensure([], () => r(require('buyerapp/views/address/selAddress')), 'selAddress')
const contractDetail = r => require.ensure([], () => r(require('buyerapp/views/contract/contractDetail')), 'contractDetail')
const activateCard = r => require.ensure([], () => r(require('buyerapp/views/wxcard/activateCard')), 'activateCard')
const cardInfo = r => require.ensure([], () => r(require('buyerapp/views/wxcard/cardInfo')), 'cardInfo')
const cardPackage = r => require.ensure([], () => r(require('buyerapp/views/wxcard/cardPackage')), 'cardPackage')
const billBrief = r => require.ensure([], () => r(require('buyerapp/views/self/bill/billBrief')), 'billBrief')
const billDetailList = r => require.ensure([], () => r(require('buyerapp/views/self/bill/billDetailList')), 'billDetailList')
const orderFilter = r => require.ensure([], () => r(require('buyerapp/views/self/bill/orderFilter')), 'orderFilter')

const pointMall = r => require.ensure([], () => r(require('buyerapp/views/points/pointMall')), 'pointMall')
const pointOrderList = r => require.ensure([], () => r(require('buyerapp/views/points/pointOrderList')), 'pointOrderList')
const walletDetail = r => require.ensure([], () => r(require('buyerapp/views/self/wallet/walletDetail')), 'walletDetail')

const ecardList = r => require.ensure([], () => r(require('buyerapp/views/self/ecard/ecardList')), 'ecardList')
const addECard = r => require.ensure([], () => r(require('buyerapp/views/self/ecard/addECard')), 'addECard')

const shopBillBrief = r => require.ensure([], () => r(require('buyerapp/views/self/shop/shopBillBrief')), 'shopBillBrief')
const deposit = r => require.ensure([], () => r(require('buyerapp/views/self/deposit/deposit')), 'deposit')
const depositResult = r => require.ensure([], () => r(require('buyerapp/views/self/deposit/depositResult')), 'depositResult')

const priceSheetDetail = r => require.ensure([], () => r(require('baseapp/views/priceSheet/priceSheetDetail')), 'priceSheetDetail')

const mallCompanyList = r => require.ensure([], () => r(require('buyerapp/views/mall/mallCompanyList')), 'mallCompanyList')
const lookForSku = r => require.ensure([], () => r(require('buyerapp/views/lookForSku/lookForSku')), 'lookForSku')
const inquiry = r => require.ensure([], () => r(require('buyerapp/views/lookForSku/inquiry')), 'inquiry')
const inquiryList = r => require.ensure([], () => r(require('buyerapp/views/lookForSku/inquiryList')), 'inquiryList')
const editInquiry = r => require.ensure([], () => r(require('buyerapp/views/lookForSku/editInquiry')), 'editInquiry')
const search = r => require.ensure([], () => r(require('buyerapp/views/goods/search')), 'search')
const applyCustom = r => require.ensure([], () => r(require('buyerapp/views/custom/applyCustom')), 'applyCustom')
Vue.use(Router)
export default new Router({
  scrollBehavior (to, from, savedPosition) {
    // if (savedPosition) {
    //   console.log('savePosition: ' + JSON.stringify(savedPosition))
    //   return savedPosition
    // } else {
    //   // if (from.meta.keepAlive) {
    //   //   let scrollTop = (window.pageYOffset ||
    //   //     document.documentElement.scrollTop ||
    //   //     document.body.scrollTop)
    //   //   console.log('keepAlive: ' + scrollTop)
    //   //   from.meta.savePosition = scrollTop
    //   // }
    //   return { x: 0, y: 0 }
    // }
    return {x: 0, y: 0}
  },
  routes: [
    ...BaseRouter.routes,
    {
      path: '',
      redirect: '/shortcut',
      alias: ['/wxmp_menu_enterbuy', '/wxcard_promotion', '/alipy_menu_enterbuy', '/xnpkg_enterbuy']
    },
    {
      path: '/home',
      redirect: '/goods'
    },
    {
      path: '/shortcut',
      component: shortcut,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/goods/:companyid?',
      component: goods,
      props: (route) => ({companyid: Number(route.params.companyid) || 1})
    },
    {
      path: '/recommend',
      component: recommend
    },
    {
      path: '/self',
      component: self
    },
    {
      path: '/spudetail/:skuid/:spuType?',
      component: goodsDetail,
      props: (route) => ({skuid: Number(route.params.skuid), spuType: route.params.spuType})
    },
    {
      path: '/shoppingcart',
      component: shoppingCart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/:orderid?',
      component: order,
      props: (route) => ({orderid: Number(route.params.orderid)}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orderresult',
      component: orderResult
    },
    {
      path: '/orderdetail/:orderid',
      component: orderDetail,
      props: (route) => ({pOrderid: Number(route.params.orderid)}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/shareorderdetail/:orderid/:shareToken',
      component: shareOrderDetail,
      props: (route) => ({pOrderid: Number(route.params.orderid), pShareToken: route.params.shareToken})
    },
    {
      path: '/addressmanage',
      component: addressManage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/editaddress/:contactid?',
      component: editAddress,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/selAddress',
      component: selAddress,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/contractdetail/:contractid',
      component: contractDetail,
      props: (route) => ({contractid: Number(route.params.contractid)}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/activatecard',
      component: activateCard
    },
    {
      path: '/cardinfo/:cardType',
      component: cardInfo,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cardpackage',
      component: cardPackage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/billbrief/:buyer_companyid?/:seller_companyid?',
      component: billBrief,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/billdetaillist',
      component: billDetailList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orderfilter',
      component: orderFilter,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pointmall',
      component: pointMall,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pointorderlist',
      component: pointOrderList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/walletdetail/:cardType',
      component: walletDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ecardlist',
      component: ecardList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/addecard',
      component: addECard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/shopbillbrief',
      component: shopBillBrief,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/deposit',
      component: deposit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/depositresult',
      component: depositResult,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pricesheetdetail/:sheetid',
      component: priceSheetDetail,
      props: (route) => ({sheetid: Number(route.params.sheetid)}),
    },
    {
      path: '/mallcompanylist',
      component: mallCompanyList
    },
    {
      path: '/lookForSku',
      component: lookForSku
    },
    {
      path: '/inquiry',
      component: inquiry,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inquiryList',
      component: inquiryList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/editInquiry',
      component: editInquiry,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      component: search
    },
    {
      path: '/applyCustom/:pCompanyid',
      props: (route) => ({pCompanyid: Number(route.params.pCompanyid)}),
      component: applyCustom,
      meta: {
        requiresAuth: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/apps/buyerapp/router/router.js